import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { getOrganizations } from '@api/lookups';
import { IAthleteRole } from '@interfaces/lookups';

export const handleGetOrganizations = createAsyncThunk<AxiosResponse<IAthleteRole[]>, void>(
  'getOrganizations',
  getOrganizations,
);
